export type QuickResponseType = 'see_proposed_correction' | 'not_accepted';

/** OOXML / HTML track-changes author for Quick Response inserts (our-side, blue). */
export const QUICK_RESPONSE_TRACK_CHANGES_AUTHOR = 'Quick Response';

/** Authors whose track changes render as our-side (blue), not counterparty (red). */
export function isOurSideTrackChangesAuthor(author: string): boolean {
  const a = author.trim();
  return a === 'AI Suggestion' || a === 'User Edit' || a === QUICK_RESPONSE_TRACK_CHANGES_AUTHOR;
}

export interface QuickResponseOption {
  id: QuickResponseType;
  label: string;
  suffix: string;
}

export const QUICK_RESPONSE_OPTIONS: QuickResponseOption[] = [
  {
    id: 'see_proposed_correction',
    label: '[ראה תיקון מוצע]',
    suffix: ' [ראה תיקון מוצע]',
  },
  {
    id: 'not_accepted',
    label: '[לא מקובל]',
    suffix: ' [לא מקובל]',
  },
];

export function buildQuickResponseText(baseText: string, type: QuickResponseType): string {
  const option = QUICK_RESPONSE_OPTIONS.find((entry) => entry.id === type);
  if (!option) return baseText.replace(/\s+/g, ' ').trim();

  const normalized = baseText.replace(/\s+/g, ' ').trim();
  const suffixTrimmed = option.suffix.trim();
  if (!normalized) return suffixTrimmed;
  if (normalized.endsWith(suffixTrimmed)) return normalized;
  return `${normalized}${option.suffix}`;
}
